import React from 'react';

const PastEvents = () => {
  const events = [
    {
      title: 'AI Day @ Anurag University',
      date: 'January 2026',
      location: 'Hyderabad',
      image: '/images/events/Anurag-University-Hyderabad-Im.png'
    },
    {
      title: 'AI Day @ Draper House',
      date: 'September 2025',
      location: 'Bangalore',
      image: '/images/events/ai day.jpeg'
    },
    {
      title: 'AI Gramshala @ Jawahar Navodya Vidalaya',
      date: 'August 2025',
      location: 'Nagarkurnool, Hyderabad',
      image: '/images/events/ai gramshala.jpeg'
    },
    {
      title: 'AI Masterclass @ Kodryx AI',
      date: 'July 2025',
      location: 'Kodryx AI Office',
      image: '/images/events/ai masterclass.jpeg'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl md:text-4xl font-outfit font-800 text-black mb-4 text-center">
          Past Events
        </h2>
        
        <div className="w-24 h-1 bg-crimson mx-auto mb-16"></div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          {events.map((event, index) => (
            <div 
              key={index}
              className="tilted-card group cursor-pointer"
            >
              <div className="bg-white rounded-lg overflow-hidden border-2 border-gray-200 hover:border-crimson transition-all duration-300 hover:animate-vibrate hover:animate-pulse-border shadow-sm">
                <div className="h-48 overflow-hidden">
                  <img 
                    src={event.image} 
                    alt={event.title} 
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-lg font-outfit font-800 text-black mb-4">
                    {event.title}
                  </h3>
                  <div className="flex items-center gap-2 mb-2 text-gray-400">
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                    </svg>
                    <span className="font-outfit font-600 text-sm">{event.date}</span>
                  </div>
                  <div className="flex items-center gap-2 text-gray-400">
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    </svg>
                    <span className="font-outfit font-600 text-sm">{event.location}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <button className="btn-secondary">
            View Event Archives
          </button>
        </div>
      </div>
    </section>
  );
};

export default PastEvents;
